module.exports = __webpack_public_path__ + "img/ino_plate.fb3214ab.gif";